import React from 'react';
import { useReveal } from '../lib/useReveal';
const PAIN_POINTS = ['Sentís que tus tortas no se ven profesionales', 'No sabés cuánto cobrar', 'No conseguís clientes', 'Te cuesta decorar', 'Tus fotos no llaman la atención', 'Querés emprender pero no sabés cómo empezar'];
export function ProblemSection() {
  const [ref, isVisible] = useReveal();
  return <section className="py-12 md:py-16 px-6 bg-[#fff8f9]" data-id="element-165">
      <div className="max-w-4xl mx-auto" data-id="element-166">
        <div className="text-center mb-8" data-id="element-167">
          <span className="inline-block text-[#e89aaa] text-xs font-bold tracking-[0.25em] uppercase mb-3" data-id="element-168">
            ♡ Es para vos ♡
          </span>
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#6b4f3a] leading-tight" data-id="element-169">
            Si te pasa esto… <br data-id="element-170" />
            <span className="italic text-[#e89aaa]" data-id="element-171">
              este MegaPack es para vos.
            </span>
          </h2>
        </div>

        <div ref={ref} className={`reveal grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-3xl mx-auto ${isVisible ? 'is-visible' : ''}`} data-id="element-172">
          {PAIN_POINTS.map((item, i) => <div key={i} className="flex items-start gap-3 bg-white border border-[#f4b6c2]/30 rounded-2xl p-5 shadow-[0_4px_20px_rgba(232,154,170,0.04)]" data-id="element-173">
              <span className="w-6 h-6 rounded-full bg-[#fdf2f4] flex items-center justify-center text-[#e89aaa] text-xs shrink-0 mt-0.5" data-id="element-174">
                ✕
              </span>
              <span className="text-[#6b4f3a] text-sm md:text-base" data-id="element-175">
                {item}
              </span>
            </div>)}
        </div>

        <p className="text-center mt-8 font-serif italic text-lg md:text-xl text-[#e89aaa]" data-id="element-176">
          Vas a transformar cada una de estas dudas en confianza.
        </p>
      </div>
    </section>;
}